import { useDispatch } from 'react-redux'
import { useCallback, useEffect } from 'react'

const defaultParams = {}

const initialLoadOptions = {
  shouldClearExistingState: true
}

export const useLoadPaginatedAudienceList = ({
  platform,
  allowFetch = true,
  params = defaultParams,
  action,
  clearAction,
  next,
  after,
  limit = 20
}) => {
  const dispatch = useDispatch()

  const load = useCallback(
    nextParams => {
      dispatch(
        action(
          {
            ...params,
            ...nextParams
          },
          platform
        )
      )
    },
    [dispatch, action, params, platform]
  )

  const loadMoreHandler = useCallback(() => {
    load({
      limit,
      ...(after && { after: after })
    })
  }, [limit, load, after])

  useEffect(() => {
    // Initial load
    allowFetch && dispatch(action({ limit, ...params }, platform, initialLoadOptions))
  }, [dispatch, allowFetch, action, params, limit, platform])

  useEffect(() => {
    return () => {
      clearAction && dispatch(clearAction())
    }
  }, [clearAction, dispatch])

  return next ? loadMoreHandler : null
}
